import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';
import CustomDataTable from '../../../../Components/CustomTable/CustomTable';
import { Triangle } from 'react-loader-spinner';
import { RestroUsers } from '../../../../services/DatabaseService/RestroUsers';
import { formatDateTime } from '../../../../Components/Common/FormatDate';

const GracePeriodLogs = () => {
    const { apiKey } = useParams();
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState(null);
    const [graceLogs, setGraceLogs] = useState([]);

    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true);
            try {
                const result = await RestroUsers.getByApiKey(apiKey);
                setUserData(result);
                setGraceLogs(result?.gracePeriodLogs || []);
            } catch (error) {
                console.error("Error fetching user data", error);
            } finally {
                setLoading(false);
            }
        };
        fetchAllData();
    }, [apiKey]);

    const customStyles = {
        headCells: {
            style: {
                fontSize: "0.92rem",
                fontWeight: 610,
                width: "max-content",
            },
        },
        rows: {
            style: {
                fontSize: "0.9rem",
            },
        },
    };

    const columns = [
        {
            name: "S No",
            selector: (row, index) => index + 1,
            width: "100px",
            sortable: true,
        },
        {
            name: "Previous Date",
            selector: (row) => formatDateTime(row.previousDate),
            sortable: true,
        },
        {
            name: "Final Date",
            selector: (row) => formatDateTime(row.finalDate),
            sortable: true,
        },
        {
            name: "Updated On",
            selector: (row) => formatDateTime(row.updatedOn),
            sortable: true,
        },
        {
            name: "Updated By",
            selector: (row) => row.updatedBy,
            sortable: true,
        },
        {
            name: "Remarks",
            selector: (row) => <span title={row.remarks}>{row.remarks}</span>,
            sortable: true,
        },
    ];

    return (
        <div className='page-content py-0'>
            <div className='container-fluid px-0'>

                {/* DESKTOP VIEW (TABLE) */}
                <Card className="d-none d-md-block d-lg-block">
                    <CardBody>
                        <CustomDataTable
                            responsive
                            striped
                            pagination
                            fixedHeader
                            persistTableHead
                            progressPending={loading}
                            customStyles={customStyles}
                            progressComponent={
                                <div className="my-3 text-center">
                                    <Triangle visible={true} height="80" width="80" color="#5B71B9" />
                                    <h5 className="mt-1">Loading...</h5>
                                </div>
                            }
                            columns={columns}
                            data={graceLogs}
                        />
                    </CardBody>
                </Card>

                {/* MOBILE VIEW (CARD LIST) */}
                {loading ? (
                    <div className="my-5 text-center d-block d-md-none">
                        <h5>Loading...</h5>
                    </div>
                ) : (
                    <>
                        {graceLogs?.map((item, index) => (
                            <Card key={index} className="mb-3 shadow-sm d-block d-md-none mt-2">
                                <CardBody>
                                    <h6 className="mb-2"><strong>S No:</strong> {index + 1}</h6>

                                    <h6 className="mb-2">
                                        <strong>Previous Date:</strong> {formatDateTime(item.previousDate)}
                                    </h6>

                                    <h6 className="mb-2">
                                        <strong>Final Date:</strong> {formatDateTime(item.finalDate)}
                                    </h6>

                                    <h6 className="mb-2">
                                        <strong>Updated On:</strong> {formatDateTime(item.updatedOn)}
                                    </h6>

                                    <h6 className="mb-2">
                                        <strong>Updated By:</strong> {item.updatedBy}
                                    </h6>

                                    <h6 className="mb-2 text-wrap">
                                        <strong>Remarks:</strong> {item.remarks}
                                    </h6>
                                </CardBody>
                            </Card>
                        ))}
                    </>
                )}

            </div>
        </div>
    );
};

export default GracePeriodLogs;
